import { useEffect } from 'react';
import { themeRegistry } from '../utils/themeRegistry';

/**
 * Hook para cargar el favicon y título del cliente desde CloudFront
 * El título se obtiene del theme.json local del cliente configurado
 * Si no existe, usa el favicon local por defecto y "Movil SGR" como título
 */
export const useFavicon = () => {
  useEffect(() => {
    const cloudFrontUrl = process.env.REACT_APP_CLOUDFRONT_S3_URL;
    const clientName = process.env.REACT_APP_CLIENT_NAME;
    
    // Cargar título desde el theme.json del cliente
    if (clientName) {
      const theme = themeRegistry.getTheme(clientName);
      if (theme?.name) {
        document.title = theme.name;
        console.log('✅ Título cargado desde theme local:', theme.name);
      } else {
        // Solo establecer "Movil SGR" si no se encontró el theme del cliente
        document.title = 'Movil SGR';
        console.log('ℹ️ Theme del cliente no encontrado, usando título por defecto');
      }
    } else {
      // Si no hay cliente configurado, usar título por defecto
      document.title = 'Movil SGR';
      console.log('ℹ️ Cliente no configurado, usando título por defecto');
    }
    
    // Cargar favicon desde CloudFront si está configurado
    if (!cloudFrontUrl) {
      console.log('ℹ️ CloudFront URL no configurada, usando favicon local');
      return;
    }

    // Construir URL del favicon
    const faviconUrl = `https://${cloudFrontUrl}/favicon.svg`;
    
    // Intentar cargar el favicon para verificar que existe
    const img = new Image();
    
    img.onload = () => {
      // Si existe, actualizar el favicon
      const faviconLink = document.getElementById('favicon') as HTMLLinkElement;
      if (faviconLink) {
        faviconLink.href = faviconUrl;
        console.log('✅ Favicon cargado desde CloudFront:', faviconUrl);
      }
    };
    
    img.onerror = () => {
      console.log('ℹ️ Favicon no encontrado en CloudFront, usando el local');
    };
    
    img.src = faviconUrl;
  }, []);
};
